import { nanoid } from "@reduxjs/toolkit";

import shoes1 from "../../../../assets/HomeShoes/firstSectionShoes/shoes1.png";
import shoes11 from "../../../../assets/HomeShoes/firstSectionShoes/shoes11.png";
import shoes12 from "../../../../assets/HomeShoes/firstSectionShoes/shoes12.png";
import shoes13 from "../../../../assets/HomeShoes/firstSectionShoes/shoes13.png";

import shoes2 from "../../../../assets/HomeShoes/firstSectionShoes/shoes2.png";
import shoes21 from "../../../../assets/HomeShoes/firstSectionShoes/shoes22.png";
import shoes22 from "../../../../assets/HomeShoes/firstSectionShoes/shoes23.png";
import shoes23 from "../../../../assets/HomeShoes/firstSectionShoes/shoes24.png";

import shoes3 from "../../../../assets/HomeShoes/firstSectionShoes/shoes3.png";
import shoes31 from "../../../../assets/HomeShoes/firstSectionShoes/shoes31.png";
import shoes32 from "../../../../assets/HomeShoes/firstSectionShoes/shoes32.png";
import shoes33 from "../../../../assets/HomeShoes/firstSectionShoes/shoes33.png";

import shoes4 from "../../../../assets/HomeShoes/firstSectionShoes/shoes4.png";
import shoes41 from "../../../../assets/HomeShoes/firstSectionShoes/shoes41.png";
import shoes42 from "../../../../assets/HomeShoes/firstSectionShoes/shoes42.png";
import shoes43 from "../../../../assets/HomeShoes/firstSectionShoes/shoes43.png";

import shoes5 from "../../../../assets/HomeShoes/firstSectionShoes/shoes5.png";
import shoes51 from "../../../../assets/HomeShoes/firstSectionShoes/shoes51.png";
import shoes52 from "../../../../assets/HomeShoes/firstSectionShoes/shoes52.png";
import shoes53 from "../../../../assets/HomeShoes/firstSectionShoes/shoes53.png";

import shoes6 from "../../../../assets/HomeShoes/firstSectionShoes/shoes6.png";
import shoes61 from "../../../../assets/HomeShoes/firstSectionShoes/shoes61.png";
import shoes62 from "../../../../assets/HomeShoes/firstSectionShoes/shoes62.png";
import shoes63 from "../../../../assets/HomeShoes/firstSectionShoes/shoes63.png";

import shoes7 from "../../../../assets/HomeShoes/firstSectionShoes/shoes7.png";
import shoes71 from "../../../../assets/HomeShoes/firstSectionShoes/shoes71.png";
import shoes72 from "../../../../assets/HomeShoes/firstSectionShoes/shoes72.png";
import shoes73 from "../../../../assets/HomeShoes/firstSectionShoes/shoes73.png";

import shoes8 from "../../../../assets/HomeShoes/firstSectionShoes/shoes8.png";
import shoes81 from "../../../../assets/HomeShoes/firstSectionShoes/shoes81.png";
import shoes82 from "../../../../assets/HomeShoes/firstSectionShoes/shoes82.png";
import shoes83 from "../../../../assets/HomeShoes/firstSectionShoes/shoes83.png";

import shoes9 from "../../../../assets/HomeShoes/firstSectionShoes/shoes9.png";
import shoes91 from "../../../../assets/HomeShoes/firstSectionShoes/shoes91.png";
import shoes92 from "../../../../assets/HomeShoes/firstSectionShoes/shoes92.png";
import shoes93 from "../../../../assets/HomeShoes/firstSectionShoes/shoes93.png";

export const sneakersShoesData = [
  {
    id: nanoid(),
    image: shoes1,
    title: "Blktop Rider Lithium Unisex Sneakers",
    price: 4490,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Inky Blue-Persian Blue",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Meet the newest member of the Puma Rider family. The Blktop Rider features a rubber outsole inspired by PUMA's track and field",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Meet the newest member of the Puma Rider family. The Blktop Rider features a rubber outsole inspired by PUMA's track and field archive from the '80s. Heritage colours and materials meet modern design elements in this new classic silhouette. This version is decked out with a mesh base and some suede uppers for a smooth look.",

    detail: [
      {
        id: nanoid(),
        point: "Mesh Upper",
      },
      {
        id: nanoid(),
        point: "Suede and synthetic overlays",
      },
      {
        id: nanoid(),
        point: "Synthetic mudguard and heel underlay",
      },
      {
        id: nanoid(),
        point: "TPU lace jewel",
      },
      {
        id: nanoid(),
        point: "EVA midsole",
      },
      {
        id: nanoid(),
        point: "Printed speckles on midsole",
      },
      {
        id: nanoid(),
        point: "Printed speckles on midsole",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point: "FVNEC HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD THANH HOA CITY",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes1,
      },
      {
        id: nanoid(),
        imgCard: shoes11,
      },
      {
        id: nanoid(),
        imgCard: shoes12,
      },
      {
        id: nanoid(),
        imgCard: shoes13,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes2,
    title: "Rider Future Vintage Unisex Sneakers",
    price: 3869,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: " White-Rickie Orange",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Step into a time capsule of style with the Rider Future Vintage Unisex Sneakers. A bold confluence of past and present, these",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Step into a time capsule of style with the Rider Future Vintage Unisex Sneakers. A bold confluence of past and present, these sneakers boast a vibrant colorblock design that merges harmoniously with futuristic details, creating a sneaker that doesn't just follow trends but sets them. And it's not just about looks - with a durable outsole, every step is a grounded experience, resonating well with every sneakerhead who appreciates the old-school charm with modern style.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 14 mm",
      },
      {
        id: nanoid(),
        point: "Ripstop nylon upper",
      },
      {
        id: nanoid(),
        point: "Suede toe, heel and eyestay overlays",
      },
      {
        id: nanoid(),
        point: "Nylon tongue with woven label",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip with nylon piping",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "Putian Baiho Footwear Co.LTD",
      },

      {
        id: nanoid(),
        point: "FVNEC FCNXB Fujian No.1518, GUCHENG EAST ROAD, HU",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes2,
      },
      {
        id: 2,
        imgCard: shoes21,
      },
      {
        id: 3,
        imgCard: shoes22,
      },
      {
        id: 4,
        imgCard: shoes23,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes3,
    title: "Fuse 2.0 Forged Men's Training Shoes",
    price: 4299,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Black",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "We worked with professional athletes to amplify three key training attributes—stability, fit, and traction. The FUSE 2.0 features",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "We worked with professional athletes to amplify three key training attributes—stability, fit, and traction. The FUSE 2.0 features increased rubber for enhanced stability, including higher sidewall coverage to ensure traction and grip. The streamlined upper construction provides durability for rope climbs, while a lightweight TPU heel clip is designed for handstand push-ups. And all this innovation comes in one sleek package to help you reach your ultimate training potential. The Forged version features some wild graphic elements across the outsole",
    detail: [
      {
        id: nanoid(),
        point:
          "STABILITY: Vertical FuseFlex lines provide improved metatarsal foot splay, while an internal midsole offers a stable stance during training workouts",
      },
      {
        id: nanoid(),
        point: "SUPPORT: TPU clip for enhanced heel support",
      },
      {
        id: nanoid(),
        point:
          "GRIP: PUMAGRIP rubber for maximum traction and durability during training movements. Go from box jumps to heavy lifts with confidence and speed.",
      },
      {
        id: nanoid(),
        point:
          "PROFOAM: Lightweight EVA designed to cushion your landing and propel your next step",
      },
      {
        id: nanoid(),
        point: "Suede toe, heel and eyestay overlays",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "Textile upper",
      },

      {
        id: nanoid(),
        point:
          "TPU heel clip PROFOAM EVA midsole PUMAGRIP rubber outsole FuseFlex vertical outsole flex grooves sockliner Textile sockliner Heel-to-toe drop: 4 mm",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes3,
      },
      {
        id: 2,
        imgCard: shoes31,
      },
      {
        id: 3,
        imgCard: shoes32,
      },
      {
        id: 4,
        imgCard: shoes33,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes4,
    title: "Playmaker Pro Mid Trophies Unisex Basketball Shoes",
    price: 4999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Ash Gray-Cast Iron-PUMA Gold",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "PUMA's SOFTRIDE technology represents an advancement in footwear comfort. It incorporates our softest foam, designed to",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Softness goes slip-on in these striking, splatter-print running shoes. Built with our celebrated SOFTRIDE comfort footbed and SoftFoam+ sockliner, the Premier is uniquely comfortable and relentlessly stylish.",
    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 5 mm",
      },
      {
        id: nanoid(),
        point: "Low boot",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "ALERON VIET NAM FOOTWEAR LIMITED",
      },

      {
        id: nanoid(),
        point:
          "FVNEC THANH HOA PROVINCE HOANG LONG INDUSTRIAL ZONE TAO XUYEN WARD THANH HOA CITY",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes4,
      },
      {
        id: 2,
        imgCard: shoes41,
      },
      {
        id: 3,
        imgCard: shoes42,
      },
      {
        id: 4,
        imgCard: shoes43,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes5,
    title: "RS 3.0 Energy Unisex Sneakers",
    price: 3999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "White-Lemon Meringue",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "A new addition to the Running System (RS) family, the RS 3.0 pays homage to the disruptive aesthetics of the RS technology and",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "A new addition to the Running System (RS) family, the RS 3.0 pays homage to the disruptive aesthetics of the RS technology and features a pod design on the midsole with a more modern, clean interpretation of the upper. This version has a mesh base with synthetic overlays.",
    detail: [
      {
        id: nanoid(),
        point: "Synthetic and mesh upper",
      },
      {
        id: nanoid(),
        point: "RS technology on midsole",
      },
      {
        id: nanoid(),
        point: "Rubber outsole",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "VMC Royal Co.Ltd.",
      },
      {
        id: nanoid(),
        point:
          "VN 22B Thanh phuoc Hamlet Thanh dien ward Chau Thanh district 840000 TAY NINH PROVINCE",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes5,
      },
      {
        id: 2,
        imgCard: shoes51,
      },
      {
        id: 3,
        imgCard: shoes52,
      },
      {
        id: 4,
        imgCard: shoes53,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes6,
    title: "Scuderia Ferrari x Joshua Vides RS-X Unisex Sneakers",
    price: 5999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Rosso Corsa-Frosted Ivory",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "In 2005, Scuderia Ferrari - the preeminent, time-honoured Formula 1 team - made a momentous decision to forge a",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Inspired by the '70s Scuderia Ferrari Racing, Joshua Vides brings his hand-painted artistry to our heritage RS-X sneaker to achieve a retro look that's ready for race day. The RS-X stands out with a bulky silhouette and moulded sockliner that combines with Vides' intricate lines integrated within Scuderia Ferrari's signature Rosso Corsa. Our old-school , '80s-era 'Running System' (RS) technology completes the style.",
    detail: [
      {
        id: nanoid(),
        point: "Low Boot",
      },
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
      {
        id: nanoid(),
        point: "Bulky silhouette",
      },
      {
        id: nanoid(),
        point: "Mesh upper",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "VMC Royal Co., Ltd.",
      },
      {
        id: nanoid(),
        point:
          "VN THIEN LOC SHOES CORPORATION 108 NGUYEN ANH THU STREET HIEP THANH WARD.,DISTRICT 12 HO CHI MINH",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes6,
      },
      {
        id: 2,
        imgCard: shoes61,
      },
      {
        id: 3,
        imgCard: shoes62,
      },
      {
        id: 4,
        imgCard: shoes63,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes7,
    title: "SOFTRIDE Premier So Splatter Men's Running Shoes",
    price: 3009,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "CASTLEROCK-Puma Black-Lime Squeeze",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "In 2005, Scuderia Ferrari - the preeminent, time-honoured Formula 1 team - made a momentous decision to forge a",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Inspired by the '70s Scuderia Ferrari Racing, Joshua Vides brings his hand-painted artistry to our heritage RS-X sneaker to achieve a retro look that's ready for race day. The RS-X stands out with a bulky silhouette and moulded sockliner that combines with Vides' intricate lines integrated within Scuderia Ferrari's signature Rosso Corsa. Our old-school , '80s-era 'Running System' (RS) technology completes the style.",
    detail: [
      {
        id: nanoid(),
        point: "Low Boot",
      },
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
      {
        id: nanoid(),
        point: "Bulky silhouette",
      },
      {
        id: nanoid(),
        point: "Mesh upper",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "VMC Royal Co., Ltd.",
      },
      {
        id: nanoid(),
        point:
          "VN THIEN LOC SHOES CORPORATION 108 NGUYEN ANH THU STREET HIEP THANH WARD.,DISTRICT 12 HO CHI MINH",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes7,
      },
      {
        id: 2,
        imgCard: shoes71,
      },
      {
        id: 3,
        imgCard: shoes72,
      },
      {
        id: 4,
        imgCard: shoes73,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes8,
    title: "PWRFrame 2 Men's Training Shoes",
    price: 6399,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Alpine Snow-Warm White-PUMA Navy",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Set the foundation for a great workout with the PWRFRAME TR 2. It has a new, improved upper over v1 and PWRFRAME technology",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Set the foundation for a great workout with the PWRFRAME TR 2. It has a new, improved upper over v1 and PWRFRAME technology in the forefoot that provides support and stability through explosive movement.",

    detail: [
      {
        id: nanoid(),
        point: "Textile upper",
      },
      {
        id: nanoid(),
        point: "Responsive midsole",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip on the medial and lateral sides",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "SAO VIET CORPORATION",
      },
      {
        id: nanoid(),
        point:
          "VN BINH DUONG PROVINCE 4 ROAD, DONG AN INDUSTRIAL ZONE, THUAN AN CITY BINH DUONG PROVINCE THUAN AN CITY",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes8,
      },
      {
        id: 2,
        imgCard: shoes81,
      },
      {
        id: 3,
        imgCard: shoes82,
      },
      {
        id: 4,
        imgCard: shoes83,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes9,
    title: "PWRFrame 2 Men's Training Shoes",
    price: 7999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Fast Yellow-PUMA Black",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Whether you’re hitting the gym or going for a run, these sneakers have your back. They come with a breathable mesh upper, and a",

    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information. For any queries, please contact Customer Service at 1111002255 or via customercare@india.com",
    productStory:
      "Whether you’re hitting the gym or going for a run, these sneakers have your back. They come with a breathable mesh upper, and a cushioned lining for support and stability. The burrito construction in the collar makes them easy to slip on and off.",

    detail: [
      {
        id: nanoid(),
        point: "Low Boot",
      },
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Shoe pronation: Neutral",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 12.0 mm",
      },
      {
        id: nanoid(),
        point: "Textile and synthetic upper",
      },
      {
        id: nanoid(),
        point: "Synthetic midsole",
      },
      {
        id: nanoid(),
        point: "Synthetic outsole",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark on the lateral sides",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo on the heel",
      },
    ],
    manufacturer: [
      {
        id: nanoid(),
        point: "PT. BUILDYET INDONESIA",
      },
      {
        id: nanoid(),
        point:
          "ID JI.Raya Lamongan- Gresik, Kel Rejosari, Kec, Deket, Kab, La mongan, Prop. Jawa Timur 62291 LAMONGAN",
      },
    ],
    cardImages: [
      {
        id: 1,
        imgCard: shoes9,
      },
      {
        id: 2,
        imgCard: shoes91,
      },
      {
        id: 3,
        imgCard: shoes92,
      },
      {
        id: 4,
        imgCard: shoes93,
      },
    ],
  },
];
